export default {
    AMPLIADA: 1,
    COMPLEMENTAR: 2,
    ESTRATEGICA: 3,
}